import useMoney from '@resources/js/app/composables/useMoney.js';
import useMortgage from '@resources/js/app/composables/useMortgage.js';

const { formatMoney, convertCurrency } = useMoney();
const { getMonthlyInterest, getMonthlyInstallments, getLoanTermMonths, getLoanX } = useMortgage();

export default (
    $wire,
    $watch,
    $dispatch,
    {
        initiallySelected,
        currencySeparator = ',',
        secondaryCurrency = null,
        currencyExchangeRate = null,
        primaryCurrency,
    },
) => ({
    selected: initiallySelected,
    currency: $wire.get('currency'),
    campaignId: $wire.get('campaignId'),
    interestRate: $wire.get('interestRate'),

    init: function () {
        if (typeof this.selectedCampaigns === 'undefined') {
            this.storeValueInAlpineStore('selectedMortgageCampaigns', {
                values: [],
            });
        }

        if (this.selected) {
            this.addCampaignToSelection(this.campaignId);
        }

        $watch('selected', value => {
            if (value === true) {
                this.addCampaignToSelection(this.campaignId);
            } else {
                this.removeCampaignFromSelection(this.campaignId);
            }
        });
    },

    get loanAmount() {
        return Alpine.store('creditAmount');
    },

    get loanTenure() {
        return Alpine.store('loanTenure');
    },

    get loanTermMonths() {
        return getLoanTermMonths(this.loanTenure);
    },

    get monthlyInterest() {
        return getMonthlyInterest(this.interestRate);
    },

    get loanx() {
        return getLoanX(this.monthlyInterest, this.loanTermMonths);
    },

    get monthlyInstallments() {
        let monthlyAmount = getMonthlyInstallments(this.loanAmount, this.loanx, this.monthlyInterest);

        let currency = primaryCurrency;
        if (secondaryCurrency !== null) {
            currency = secondaryCurrency;
            monthlyAmount = convertCurrency(monthlyAmount, currencyExchangeRate);
        }

        return formatMoney(monthlyAmount, currencySeparator, currency, 'before');
    },

    get selectedCampaigns() {
        return Alpine.store('selectedMortgageCampaigns');
    },

    checkIfEnabled() {
        return this.listingPrice <= this.maxPropertyPrice && this.listingPrice >= this.minPropertyPrice;
    },

    addCampaignToSelection(id) {
        if (this.selectedCampaigns.values.indexOf(id) === -1) {
            let newSelectedCampaigns = JSON.parse(JSON.stringify(this.selectedCampaigns));
            newSelectedCampaigns.values.push(id);

            $dispatch('campaignSelection', {
                selection: {
                    selected: true,
                    campaign: id,
                },
            });

            this.storeValueInAlpineStore('selectedMortgageCampaigns', {
                values: newSelectedCampaigns.values,
            });
        }
    },

    removeCampaignFromSelection(id) {
        let newSelectedCampaigns = JSON.parse(JSON.stringify(this.selectedCampaigns));
        newSelectedCampaigns.values = newSelectedCampaigns.values.filter(val => val !== id);

        this.storeValueInAlpineStore('selectedMortgageCampaigns', {
            values: newSelectedCampaigns.values,
        });
    },

    storeValueInAlpineStore(storeName, value) {
        Alpine.store(storeName, value);
    },
});
